$(document).ready(function() {
	bindDatePicker();
	bindRoomSelector();
			
	if(siteId == 1){
		$("#poPhone").mask("(999) 999-9999");
	}else{
		$("#poPhone").mask("999999999999999");
	}
	
	$("#gsm_code").intlTelInput({
		preferredCountries: [countryCode],
		americaMode: false
	});

	$("#gsm_code").focusout(function(){
		var isTR = $("[name=gsm_code]").val().includes("+90");
		if(isTR){
			$("[name=poPhone]").mask("(999) 999-9999");
		}else{
			$("[name=poPhone]").mask("999999999999999");
		}
	});
	
	$("#formPo").letterCase($.cookie('siteLocale')).validate({
		focusInvalid: false				
	});
	
	$("#email").validate();
	
	$.widget("custom.catcomplete", $.ui.autocomplete, {
		_renderMenu : function(ul, items) {
			var that = this, currentCategory = "";
			$.each(items, function(index, item) {
				if (item.category != currentCategory) {
					if (item.category == "HOTEL") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconHotel' >" + FmtMessage.getMessage('js.result.hotel') + "</li>");
					} else if (item.category == "CITY") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconCity' >" + FmtMessage.getMessage('js.result.city') + "</li>");
					} else if (item.category == "DISTRICT") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconDistrict' >" + FmtMessage.getMessage('js.result.district') + "</li>");
					} else if (item.category == "CATEGORY") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconHotel' >" + FmtMessage.getMessage('js.result.hotel.category') + "</li>");
					}

					currentCategory = item.category;
				}
				that._renderItemData(ul, item);
			});
		},
        _renderItem: function (ul, item) {
    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
    		return $("<li class='ui-autocomplete-item'></li>")
    			.data("ui-autocomplete-item", item)
    			.append("<a>" + item.label + "</a>")
    			.appendTo(ul);
    		}
	});
	
	var re = null;
	$(".hotelAutoComplete").catcomplete(
	{   delay: 500,
		source : function(request, response) {
			$.ajax({
				url : "/hotel/hotels",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term
				},
				success: function(data) {
					if(data == null){
						data = [];
					}
					
					var itemList = $.map(data, function(item) {
						return {
							value: item.name + " ( " + item.hotelCount + " "+ FmtMessage.getMessage('js.title.hotel.name') + " ) ",
							key: item.id,
							category : item.type,
							name : item.name,
							hotelId:item.hotelId
						};
					});
					
					re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
					
					var itemListNew = getHotelItemLabels(itemList);
					response(itemListNew);
				}				
			});
		},
		minLength : 2,
		select: function (a, b) {
			document.activeElement.blur();
			if(b.item.hotelId){
				$('[name="id"]', this.form).val(b.item.hotelId);
			}
			$('[name="id"]', this.form).val(b.item.key);
			$(this).data("autoCompleteResult", b.item.value);
			
			if(!$('[name="urlHotelName"]').length ){
				$('<input>').attr({
				    type: 'hidden',
				    id: 'urlHotelName',
				    name: 'urlHotelName'
				}).appendTo(this.form);
			}
			$('[name="urlHotelName"]').val(b.item.name);
		},
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    }
	}).change(function (event) {
		if ($(this).data("autoCompleteResult") != this.value)
			$('[name="id"]', this.form).val("");
	});

	$.ui.autocomplete.prototype._renderItem = function (ul, item) {
		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
		return $("<li></li>")
			.data("ui-autocomplete-item", item)
			.append("<a>" + item.label + "</a>")
			.appendTo(ul);
	};
	$(".hotelAutoComplete").click(function() {
		$(this).select();
	});

});

function getHotelItemLabels(itemList){
	var itemListNew = $.map(itemList, function(item) {
		var category = item.category;
		if (category == "HOTEL" || category == "CATEGORY"){
			item.value = item.name;
		}
		return item;
	});
	
	return itemListNew;
}

function bindDatePicker() {
	if ($('#poDates').length == 0) {
		return;
	}
	
	$('#poDates').daterangepicker({
      minDate: moment(),
      minYear: 2022,
      maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
      locale: {
        format: 'DD.MM.YYYY'
      },
      startDate: $('input[name="checkInDate"]').val().length > 0 ? moment($('input[name="checkInDate"]').val(),'DD.MM.YYYY') : moment(),
      endDate: $('input[name="checkOutDate"]').val().length > 0 ? moment($('input[name="checkOutDate"]').val(),'DD.MM.YYYY') : moment()
    });
    
    $('#poDates').on('apply.daterangepicker', function(ev, picker) {
  		$('input[name="checkInDate"]').val(picker.startDate.format('DD.MM.YYYY'));
  		$('input[name="checkOutDate"]').val(picker.endDate.format('DD.MM.YYYY'));
	});
}

function bindRoomSelector(context) {
	if (context == undefined)
		context = document;
	
	$(".roomSelect", context).on('change', function(event) {
		var roomCount = $(this).val();
		$(".roomSelect").val(roomCount);
		$(".travelerSelectRoom").html(roomCount);
		
		for ( var i = 1; i < 5; i++) {
			if (i <= roomCount) {
				$(".room" + i).addClass('d-flex').show();
			} else {
				$(".room" + i).hide().removeClass('d-flex');
			}
		}
		
		setTotalGuest($(this).closest("form"));
		
		var locale = $.cookie('siteLocale');
		if(locale == "en" && roomCount > 1){
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.rooms'));
		}else{
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.room'));
		}
	}).change();

	$(".childCount", context).on('change', function (event) {
		var childCount =  parseInt(this.value);
		var index = this.name.split('_')[1];
		$("[name="+this.name+"]").val(childCount);

		for ( var i = 1; i < 4; i++) {
			if (i <= childCount) {
				$(".childAge" + index + i).show();
			} else {
				$(".childAge" + index + i).hide();
			}
		}
		
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".adultCount", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".childAge", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
	}).change();
}

function setTotalGuest(form) {
	var roomCount = parseInt(form.find("#glRoomCount").val());
	var totalAdultCount = 0;
	var totalChildCount = 0;
	for ( var i = 1; i <= roomCount; i++) {
		totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
		totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
	}
	var totalGuest = totalAdultCount + totalChildCount;
	$(".travelerSelectGuest").html(totalGuest);
	var locale = $.cookie('siteLocale');
	if(locale == "en" && totalGuest > 1){
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guests'));
	}else{
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guest'));
	}
}

function sendInfo(){
	var email = $("#email").val();
	var gsm = $("#poPhone").val();
	var isEmailValid = emailValidation('email');
	if(grecaptcha.getResponse().length == 0){
		alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
		return false;
	}
	if (!isEmailValid) {
		grecaptcha.reset();
		return false;
	}	
	if (email == "") {
		alert(FmtMessage.getMessage('js.invite.emptyEmail.warn'));
	}else{
		$.ajax({
	    	type:'POST',
	        async:false,
	        url: '/hotel/priceoffer',
	        data: $("#formPo").serialize(),
	        success: function(data) {
	        	$("#response").show();
				$(window).scrollTop(0);
	        	if(data){
	        		$("#failure").hide();
	        		$("#success").show();
					$('html, body').animate({scrollTop:$('#price-offer').offset().top}, '100');
					$("#formPo").validate().cancelSubmit = true;
	        	}else{
	        		$("#success").hide();	
	        		$("#failure").show();
	        	}
	         },
	        error: function() {
	            //alert('Error occured');
	        }
	    });
//		var url = "/hotel/priceoffer";
//		$('#formPo').attr('action', url).submit();
		grecaptcha.reset();
	}
}